import { Component, EventEmitter, HostBinding, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'my-subscription-card',
  templateUrl: './my-subscription-card.component.html',
  styleUrls: ['./my-subscription-card.component.scss'],
})
export class MySubscriptionCardComponent implements OnInit {
   private _color?: string;
  private _selectedColor?: string;
  private _Tcolor?: string;
  private _selectedTColor?: string;
  
  @Input()
  set color(value: string | undefined) {
    this._color = value;
    this._Tcolor = value;
  }

  @Input()
  set selectedColor(value: string | undefined) {
    this._selectedColor = value;
    this._selectedTColor = value;
  }
    @HostBinding('style.--button-color')
  get buttonColor(): string | null {
    return this._color ? `var(--ion-color-${this._color})` : null;
  }

  @HostBinding('style.--button-selected-color')
  get buttonSelectedColor(): string | null {
    return this._selectedColor ? `var(--ion-color-${this._selectedColor})` : null;
  }
      @HostBinding('style.--button-Tcolor')
  get buttonTColor(): string | null {
    return this._Tcolor ? `var(--ion-text-${this._color})` : null;
  }

  @HostBinding('style.--button-selected-Tcolor')
  get buttonSelectedTColor(): string | null {
    return this._selectedTColor ? `var(--ion-text-${this._selectedColor})` : null;
  }
  // @Input() disabled: boolean = false;

  @Input() subscriptions: any = [];
  // @Input() type: any = [];

  // @Input() isActive: boolean = false;

  @Output() freezeClick? = new EventEmitter<void>();
  @Output() upgradeClick? = new EventEmitter<void>();
  @Output() renewClick? = new EventEmitter<void>();
  @Output() payClick? = new EventEmitter<void>();


  constructor() {}
ngOnInit(): void {
  console.log(this.subscriptions,'component');
}

  getGradientStyle(): { [key: string]: string } {
    if (this.color) {
            const gradient = `linear-gradient(
        var(--ion-shadeLight-${this.color}),
        var(--ion-color-${this.color}),
        var(--ion-shadeLight-${this.color})
      )`;
      return { 'background-image': gradient };
    }
    return {}; // Return empty object if no color is provided
  }
       getIconStyle(): { [key: string]: string } {
    if (this.color) {
      const color = `var(--ion-shadeLight-${this.color})`
      return { 'color': color };
    }
    return {}; // Return empty object if no color is provided
  }
      getSelectedStyle(): { [key: string]: string } {
    if (this.selectedColor) {
            const gradient = `linear-gradient(
        var(--ion-shadeLight-${this.selectedColor}),
        var(--ion-color-${this.selectedColor}),
        var(--ion-shadeLight-${this.selectedColor})
      )`;
      return { 'background-image': gradient };
    }
    return {}; // Return empty object if no color is provided
  }
   
  async onFreezeClick() {
    this.freezeClick.emit(); 
  }
    async onUpgradeClick() {
    this.upgradeClick.emit(); 
  }
    async onRenewClick() {
    this.renewClick.emit(); 
  }

}